import { Content, ContentWrapper } from "./сhapter.styles";
import Paragraph from "../Paragraph/paragraph";
import React, { useEffect, useRef, useState } from "react";
import { useChapterDisplayDataContext } from "contexts/ChapterDisplayContext";
import {motion, AnimatePresence} from "framer-motion";

export default function ChapterContent() {
  const {chapter, isCollapsed} = useChapterDisplayDataContext();
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    if (!isCollapsed) {
      setHeight(0);
      return;
    }

    setHeight(element.scrollHeight);

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
      }
    });
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, [isCollapsed, chapter.paragraphs]);

  return (
    <ContentWrapper style={{ height: `${height}px` }}>
      <Content ref={contentRef}>
        <AnimatePresence>
          {chapter.paragraphs.map((p) => (
            <motion.div
              initial="hidden"
              animate="visible"
              exit="exit"
              key={p.uuid}
            >
              <Paragraph key={p.uuid} paragraph={p}/>
            </motion.div>
          ))}
        </AnimatePresence>
      </Content>
    </ContentWrapper>
  )
}
